import { axiosCompanyPortalInstance } from "./";

/**
 * Company Portal events API (PROLINE-2274).
 * Paths are relative to `REACT_APP_COMPANY_PORTAL_API_BASE_URL` (typically `.../api/company_portal/v1`).
 */

const getCompanyPortalEventsList = (params = {}) =>
  axiosCompanyPortalInstance.get("/events", { params });

const getCompanyPortalEvent = (id) =>
  axiosCompanyPortalInstance.get(`/events/${id}`);

const createCompanyPortalEvent = (data) =>
  axiosCompanyPortalInstance.post("/events", data);

const updateCompanyPortalEvent = ({ data, id }) =>
  axiosCompanyPortalInstance.patch(`/events/${id}`, data);

/**
 * PROLINE-4005 — crew size plans priced for the event's company (four standard cards).
 * PROLINE-4060 — `{ is_upgrade: true, page: -1 }` lists the bigger plans with their `upgrade_cost`.
 */
const getCompanyPortalEventCrewSizePlans = (eventId, params, config) =>
  axiosCompanyPortalInstance.get(`/events/${eventId}/crew_size_plans`, { params, ...config });

/** PROLINE-4016 — Yoram's bank details for the offline transfer. */
const getCompanyPortalBankAccountInfo = () =>
  axiosCompanyPortalInstance.get("/bank_account_info");

/**
 * PROLINE-4016 — submits the publishing request (replaces `POST /events/:id/publish`).
 * `data`: `{ event_id, crew_size_plan_id, payment_type, payment_proof_url }`.
 */
const createCompanyPortalPaymentRequest = (data, config) =>
  axiosCompanyPortalInstance.post("/payment_requests", data, config);

/** PROLINE-4016 — cancels a pending publishing request; the event returns to draft. */
const cancelCompanyPortalPaymentRequest = (id, config) =>
  axiosCompanyPortalInstance.post(`/payment_requests/${id}/cancel`, undefined, config);

const cancelCompanyPortalEvent = (id) =>
  axiosCompanyPortalInstance.post(`/events/${id}/cancel`);

const deleteCompanyPortalEvent = (id) =>
  axiosCompanyPortalInstance.delete(`/events/${id}`);

const getCompanyPortalEventConflictingResources = ({ id, params }) =>
  axiosCompanyPortalInstance.get(`/events/${id}/conflicting_resources`, {
    params,
  });

/** PROLINE-3179 — event-level automatic-deduction flags. */
const updateCompanyPortalEventAutoDeduction = ({ id, params }) =>
  axiosCompanyPortalInstance.patch(`/events/${id}/update_auto_deduction`, params);

/** PROLINE-3796 — `calculate_by_checkin_only` ("Pay Full Scheduled Shift"). */
const updateCompanyPortalEventCalculationSettings = ({ id, params }) =>
  axiosCompanyPortalInstance.patch(`/events/${id}/update_calculation_settings`, params);

const getCompanyPortalLookups = (keys = []) =>
  axiosCompanyPortalInstance.get("/lookups", {
    params: { keys: keys.join(",") },
  });

export {
  getCompanyPortalEventsList,
  getCompanyPortalEvent,
  createCompanyPortalEvent,
  updateCompanyPortalEvent,
  getCompanyPortalEventCrewSizePlans,
  getCompanyPortalBankAccountInfo,
  createCompanyPortalPaymentRequest,
  cancelCompanyPortalPaymentRequest,
  cancelCompanyPortalEvent,
  deleteCompanyPortalEvent,
  getCompanyPortalEventConflictingResources,
  updateCompanyPortalEventAutoDeduction,
  updateCompanyPortalEventCalculationSettings,
  getCompanyPortalLookups,
};
